import React from 'react';
import PropTypes from 'prop-types';
import Section from '../components/section';

const NearbyItem = ({ title: blockTitle, icon, places }) => (
  <div className="list-group">
    <div className={`list-icon ${icon}`} />
    <h3 className="title-3">{blockTitle}</h3>
    <ul className="list">
      {places.map(({ id, title, distance }) => (
        <li key={id} className="list-item">
          {title}
          <span className="list-thumb">
            {distance}
            {' км'}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

const Nearby = ({ items }) => (
  <Section title="Ориентиры поблизости">
    <div className="row row--wrap">
      {items.map(({
        node: {
          id, title, icon, places,
        },
      }) => (
        <div key={id} className="col-xs-12 col-sm-6 col-md-4">
          <NearbyItem {...{ title, icon, places }} />
        </div>
      ))}
    </div>
  </Section>
);

NearbyItem.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  places: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

Nearby.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

export default Nearby;
